"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MONTH = void 0;
exports.MONTH = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: () => {
        throw new Error('Function:MONTH not implemented');
    },
};
//# sourceMappingURL=month.js.map